/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateProductRequest,
  CreateProductResult,
  CreateProjectRequest,
  CreateSerieRequest,
  GenerateTermsRequest,
  GenerateTermsResponse,
  GetCalendarTermsResponse,
  GetDestinationSeasonOptionsResponse,
  GetPlanningTreeResponse,
  GetProductResponse,
  GetProjectResponse,
  GetSerieDetailResponse,
  GetSerieEconomicsResponse,
  GetVenuaPlannerCalendarTermsParams,
  GetVenuaPlannerDestinationSeasonOptionsParams,
  ListRequest,
  ListResponseOfAvailableLegacyProductSuggestion,
  ListResponseOfDestinationSuggestion,
  ListResponseOfPersonSuggestion,
  ListResponseOfRegularTransportSuggestion,
  UpdateProductDestinationsRequest,
  UpdateProjectRequest,
  UpdateSerieRequest
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const getVenuaPlannerCalendarTerms = (
    params: GetVenuaPlannerCalendarTermsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetCalendarTermsResponse>(
      {url: `/api/venua-planner/calendar`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetVenuaPlannerCalendarTermsQueryKey = (params?: GetVenuaPlannerCalendarTermsParams,) => {
    return [
    `/api/venua-planner/calendar`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVenuaPlannerCalendarTermsQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError = ErrorType<unknown>>(params: GetVenuaPlannerCalendarTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerCalendarTermsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>> = ({ signal }) => getVenuaPlannerCalendarTerms(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerCalendarTermsQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>>
export type GetVenuaPlannerCalendarTermsQueryError = ErrorType<unknown>


export function useGetVenuaPlannerCalendarTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError = ErrorType<unknown>>(
 params: GetVenuaPlannerCalendarTermsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerCalendarTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError = ErrorType<unknown>>(
 params: GetVenuaPlannerCalendarTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerCalendarTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError = ErrorType<unknown>>(
 params: GetVenuaPlannerCalendarTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerCalendarTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError = ErrorType<unknown>>(
 params: GetVenuaPlannerCalendarTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerCalendarTermsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVenuaPlannerDestinationSeasonOptions = (
    params?: GetVenuaPlannerDestinationSeasonOptionsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetDestinationSeasonOptionsResponse>(
      {url: `/api/venua-planner/destination-seasons`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetVenuaPlannerDestinationSeasonOptionsQueryKey = (params?: GetVenuaPlannerDestinationSeasonOptionsParams,) => {
    return [
    `/api/venua-planner/destination-seasons`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVenuaPlannerDestinationSeasonOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError = ErrorType<unknown>>(params?: GetVenuaPlannerDestinationSeasonOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerDestinationSeasonOptionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>> = ({ signal }) => getVenuaPlannerDestinationSeasonOptions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerDestinationSeasonOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>>
export type GetVenuaPlannerDestinationSeasonOptionsQueryError = ErrorType<unknown>


export function useGetVenuaPlannerDestinationSeasonOptions<TData = Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError = ErrorType<unknown>>(
 params: undefined |  GetVenuaPlannerDestinationSeasonOptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerDestinationSeasonOptions<TData = Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError = ErrorType<unknown>>(
 params?: GetVenuaPlannerDestinationSeasonOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerDestinationSeasonOptions<TData = Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError = ErrorType<unknown>>(
 params?: GetVenuaPlannerDestinationSeasonOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerDestinationSeasonOptions<TData = Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError = ErrorType<unknown>>(
 params?: GetVenuaPlannerDestinationSeasonOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerDestinationSeasonOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVenuaPlannerDestinationSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfDestinationSuggestion>(
      {url: `/api/venua-planner/destinations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetVenuaPlannerDestinationSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getVenuaPlannerDestinationSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getVenuaPlannerDestinationSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetVenuaPlannerDestinationSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>>
    export type GetVenuaPlannerDestinationSuggestionsMutationBody = ListRequest
    export type GetVenuaPlannerDestinationSuggestionsMutationError = ErrorType<unknown>

    export const useGetVenuaPlannerDestinationSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetVenuaPlannerDestinationSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerAvailableLegacyProductSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfAvailableLegacyProductSuggestion>(
      {url: `/api/venua-planner/legacy-products/available`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetVenuaPlannerAvailableLegacyProductSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getVenuaPlannerAvailableLegacyProductSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getVenuaPlannerAvailableLegacyProductSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetVenuaPlannerAvailableLegacyProductSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>>
    export type GetVenuaPlannerAvailableLegacyProductSuggestionsMutationBody = ListRequest
    export type GetVenuaPlannerAvailableLegacyProductSuggestionsMutationError = ErrorType<unknown>

    export const useGetVenuaPlannerAvailableLegacyProductSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetVenuaPlannerAvailableLegacyProductSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerPersonSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfPersonSuggestion>(
      {url: `/api/venua-planner/persons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetVenuaPlannerPersonSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getVenuaPlannerPersonSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getVenuaPlannerPersonSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetVenuaPlannerPersonSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>>
    export type GetVenuaPlannerPersonSuggestionsMutationBody = ListRequest
    export type GetVenuaPlannerPersonSuggestionsMutationError = ErrorType<unknown>

    export const useGetVenuaPlannerPersonSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetVenuaPlannerPersonSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerProduct = (
    productId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProductResponse>(
      {url: `/api/venua-planner/products/${productId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerProductQueryKey = (productId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}`
    ] as const;
    }

    
export const getGetVenuaPlannerProductQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError = ErrorType<void>>(productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerProductQueryKey(productId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerProduct>>> = ({ signal }) => getVenuaPlannerProduct(productId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerProductQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerProduct>>>
export type GetVenuaPlannerProductQueryError = ErrorType<void>


export function useGetVenuaPlannerProduct<TData = Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError = ErrorType<void>>(
 productId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerProduct>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerProduct>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerProduct<TData = Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError = ErrorType<void>>(
 productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerProduct>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerProduct>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerProduct<TData = Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError = ErrorType<void>>(
 productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerProduct<TData = Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError = ErrorType<void>>(
 productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerProductQueryOptions(productId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateVenuaPlannerProductDestinations = (
    productId: string,
    updateProductDestinationsRequest: UpdateProductDestinationsRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/destinations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateProductDestinationsRequest
    },
      );
    }
  


export const getUpdateVenuaPlannerProductDestinationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProductDestinations>>, TError,{productId: string;data: UpdateProductDestinationsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProductDestinations>>, TError,{productId: string;data: UpdateProductDestinationsRequest}, TContext> => {

const mutationKey = ['updateVenuaPlannerProductDestinations'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenuaPlannerProductDestinations>>, {productId: string;data: UpdateProductDestinationsRequest}> = (props) => {
          const {productId,data} = props ?? {};

          return  updateVenuaPlannerProductDestinations(productId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVenuaPlannerProductDestinationsMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenuaPlannerProductDestinations>>>
    export type UpdateVenuaPlannerProductDestinationsMutationBody = UpdateProductDestinationsRequest
    export type UpdateVenuaPlannerProductDestinationsMutationError = ErrorType<unknown>

    export const useUpdateVenuaPlannerProductDestinations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProductDestinations>>, TError,{productId: string;data: UpdateProductDestinationsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenuaPlannerProductDestinations>>,
        TError,
        {productId: string;data: UpdateProductDestinationsRequest},
        TContext
      > => {

      const mutationOptions = getUpdateVenuaPlannerProductDestinationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const createVenuaPlannerSerie = (
    productId: string,
    createSerieRequest: CreateSerieRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/venua-planner/products/${productId}/series`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSerieRequest, signal
    },
      );
    }
  


export const getCreateVenuaPlannerSerieMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerSerie>>, TError,{productId: string;data: CreateSerieRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerSerie>>, TError,{productId: string;data: CreateSerieRequest}, TContext> => {

const mutationKey = ['createVenuaPlannerSerie'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenuaPlannerSerie>>, {productId: string;data: CreateSerieRequest}> = (props) => {
          const {productId,data} = props ?? {};

          return  createVenuaPlannerSerie(productId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVenuaPlannerSerieMutationResult = NonNullable<Awaited<ReturnType<typeof createVenuaPlannerSerie>>>
    export type CreateVenuaPlannerSerieMutationBody = CreateSerieRequest
    export type CreateVenuaPlannerSerieMutationError = ErrorType<unknown>

    export const useCreateVenuaPlannerSerie = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerSerie>>, TError,{productId: string;data: CreateSerieRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenuaPlannerSerie>>,
        TError,
        {productId: string;data: CreateSerieRequest},
        TContext
      > => {

      const mutationOptions = getCreateVenuaPlannerSerieMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateVenuaPlannerSerie = (
    productId: string,
    serieId: string,
    updateSerieRequest: UpdateSerieRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSerieRequest
    },
      );
    }
  


export const getUpdateVenuaPlannerSerieMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerSerie>>, TError,{productId: string;serieId: string;data: UpdateSerieRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerSerie>>, TError,{productId: string;serieId: string;data: UpdateSerieRequest}, TContext> => {

const mutationKey = ['updateVenuaPlannerSerie'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenuaPlannerSerie>>, {productId: string;serieId: string;data: UpdateSerieRequest}> = (props) => {
          const {productId,serieId,data} = props ?? {};

          return  updateVenuaPlannerSerie(productId,serieId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVenuaPlannerSerieMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenuaPlannerSerie>>>
    export type UpdateVenuaPlannerSerieMutationBody = UpdateSerieRequest
    export type UpdateVenuaPlannerSerieMutationError = ErrorType<unknown>

    export const useUpdateVenuaPlannerSerie = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerSerie>>, TError,{productId: string;serieId: string;data: UpdateSerieRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenuaPlannerSerie>>,
        TError,
        {productId: string;serieId: string;data: UpdateSerieRequest},
        TContext
      > => {

      const mutationOptions = getUpdateVenuaPlannerSerieMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerSerieDetail = (
    productId: string,
    serieId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetSerieDetailResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerSerieDetailQueryKey = (productId?: string,
    serieId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}`
    ] as const;
    }

    
export const getGetVenuaPlannerSerieDetailQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError = ErrorType<void>>(productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerSerieDetailQueryKey(productId,serieId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>> = ({ signal }) => getVenuaPlannerSerieDetail(productId,serieId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerSerieDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>>
export type GetVenuaPlannerSerieDetailQueryError = ErrorType<void>


export function useGetVenuaPlannerSerieDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerSerieDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerSerieDetailQueryOptions(productId,serieId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVenuaPlannerSerieEconomics = (
    productId: string,
    serieId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetSerieEconomicsResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/economics`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerSerieEconomicsQueryKey = (productId?: string,
    serieId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/economics`
    ] as const;
    }

    
export const getGetVenuaPlannerSerieEconomicsQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError = ErrorType<void>>(productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerSerieEconomicsQueryKey(productId,serieId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>> = ({ signal }) => getVenuaPlannerSerieEconomics(productId,serieId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerSerieEconomicsQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>>
export type GetVenuaPlannerSerieEconomicsQueryError = ErrorType<void>


export function useGetVenuaPlannerSerieEconomics<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieEconomics<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieEconomics<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerSerieEconomics<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerSerieEconomicsQueryOptions(productId,serieId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const generateVenuaPlannerTerms = (
    productId: string,
    serieId: string,
    generateTermsRequest: GenerateTermsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenerateTermsResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateTermsRequest, signal
    },
      );
    }
  


export const getGenerateVenuaPlannerTermsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateVenuaPlannerTerms>>, TError,{productId: string;serieId: string;data: GenerateTermsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateVenuaPlannerTerms>>, TError,{productId: string;serieId: string;data: GenerateTermsRequest}, TContext> => {

const mutationKey = ['generateVenuaPlannerTerms'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateVenuaPlannerTerms>>, {productId: string;serieId: string;data: GenerateTermsRequest}> = (props) => {
          const {productId,serieId,data} = props ?? {};

          return  generateVenuaPlannerTerms(productId,serieId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateVenuaPlannerTermsMutationResult = NonNullable<Awaited<ReturnType<typeof generateVenuaPlannerTerms>>>
    export type GenerateVenuaPlannerTermsMutationBody = GenerateTermsRequest
    export type GenerateVenuaPlannerTermsMutationError = ErrorType<unknown>

    export const useGenerateVenuaPlannerTerms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateVenuaPlannerTerms>>, TError,{productId: string;serieId: string;data: GenerateTermsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateVenuaPlannerTerms>>,
        TError,
        {productId: string;serieId: string;data: GenerateTermsRequest},
        TContext
      > => {

      const mutationOptions = getGenerateVenuaPlannerTermsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const createVenuaPlannerProject = (
    createProjectRequest: CreateProjectRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/venua-planner/projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProjectRequest, signal
    },
      );
    }
  


export const getCreateVenuaPlannerProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProject>>, TError,{data: CreateProjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProject>>, TError,{data: CreateProjectRequest}, TContext> => {

const mutationKey = ['createVenuaPlannerProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenuaPlannerProject>>, {data: CreateProjectRequest}> = (props) => {
          const {data} = props ?? {};

          return  createVenuaPlannerProject(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVenuaPlannerProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createVenuaPlannerProject>>>
    export type CreateVenuaPlannerProjectMutationBody = CreateProjectRequest
    export type CreateVenuaPlannerProjectMutationError = ErrorType<unknown>

    export const useCreateVenuaPlannerProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProject>>, TError,{data: CreateProjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenuaPlannerProject>>,
        TError,
        {data: CreateProjectRequest},
        TContext
      > => {

      const mutationOptions = getCreateVenuaPlannerProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateVenuaPlannerProject = (
    projectId: string,
    updateProjectRequest: UpdateProjectRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/projects/${projectId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateProjectRequest
    },
      );
    }
  


export const getUpdateVenuaPlannerProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProject>>, TError,{projectId: string;data: UpdateProjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProject>>, TError,{projectId: string;data: UpdateProjectRequest}, TContext> => {

const mutationKey = ['updateVenuaPlannerProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenuaPlannerProject>>, {projectId: string;data: UpdateProjectRequest}> = (props) => {
          const {projectId,data} = props ?? {};

          return  updateVenuaPlannerProject(projectId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVenuaPlannerProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenuaPlannerProject>>>
    export type UpdateVenuaPlannerProjectMutationBody = UpdateProjectRequest
    export type UpdateVenuaPlannerProjectMutationError = ErrorType<unknown>

    export const useUpdateVenuaPlannerProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProject>>, TError,{projectId: string;data: UpdateProjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenuaPlannerProject>>,
        TError,
        {projectId: string;data: UpdateProjectRequest},
        TContext
      > => {

      const mutationOptions = getUpdateVenuaPlannerProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerProject = (
    projectId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProjectResponse>(
      {url: `/api/venua-planner/projects/${projectId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerProjectQueryKey = (projectId?: string,) => {
    return [
    `/api/venua-planner/projects/${projectId}`
    ] as const;
    }

    
export const getGetVenuaPlannerProjectQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError = ErrorType<void>>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerProjectQueryKey(projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerProject>>> = ({ signal }) => getVenuaPlannerProject(projectId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerProject>>>
export type GetVenuaPlannerProjectQueryError = ErrorType<void>


export function useGetVenuaPlannerProject<TData = Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError = ErrorType<void>>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerProject>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerProject>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerProject<TData = Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError = ErrorType<void>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerProject>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerProject>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerProject<TData = Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError = ErrorType<void>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerProject<TData = Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError = ErrorType<void>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerProjectQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const archiveVenuaPlannerProject = (
    projectId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/projects/${projectId}/archive`, method: 'POST', signal
    },
      );
    }
  


export const getArchiveVenuaPlannerProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveVenuaPlannerProject>>, TError,{projectId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveVenuaPlannerProject>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['archiveVenuaPlannerProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveVenuaPlannerProject>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  archiveVenuaPlannerProject(projectId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchiveVenuaPlannerProjectMutationResult = NonNullable<Awaited<ReturnType<typeof archiveVenuaPlannerProject>>>
    
    export type ArchiveVenuaPlannerProjectMutationError = ErrorType<unknown>

    export const useArchiveVenuaPlannerProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveVenuaPlannerProject>>, TError,{projectId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveVenuaPlannerProject>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getArchiveVenuaPlannerProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const createVenuaPlannerProduct = (
    projectId: string,
    createProductRequest: CreateProductRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateProductResult>(
      {url: `/api/venua-planner/projects/${projectId}/products`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProductRequest, signal
    },
      );
    }
  


export const getCreateVenuaPlannerProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProduct>>, TError,{projectId: string;data: CreateProductRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProduct>>, TError,{projectId: string;data: CreateProductRequest}, TContext> => {

const mutationKey = ['createVenuaPlannerProduct'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenuaPlannerProduct>>, {projectId: string;data: CreateProductRequest}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createVenuaPlannerProduct(projectId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVenuaPlannerProductMutationResult = NonNullable<Awaited<ReturnType<typeof createVenuaPlannerProduct>>>
    export type CreateVenuaPlannerProductMutationBody = CreateProductRequest
    export type CreateVenuaPlannerProductMutationError = ErrorType<unknown>

    export const useCreateVenuaPlannerProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProduct>>, TError,{projectId: string;data: CreateProductRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenuaPlannerProduct>>,
        TError,
        {projectId: string;data: CreateProductRequest},
        TContext
      > => {

      const mutationOptions = getCreateVenuaPlannerProductMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const unarchiveVenuaPlannerProject = (
    projectId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/projects/${projectId}/unarchive`, method: 'POST', signal
    },
      );
    }
  


export const getUnarchiveVenuaPlannerProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>, TError,{projectId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['unarchiveVenuaPlannerProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  unarchiveVenuaPlannerProject(projectId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveVenuaPlannerProjectMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>>
    
    export type UnarchiveVenuaPlannerProjectMutationError = ErrorType<unknown>

    export const useUnarchiveVenuaPlannerProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>, TError,{projectId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getUnarchiveVenuaPlannerProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerRegularTransportSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfRegularTransportSuggestion>(
      {url: `/api/venua-planner/regular-transports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetVenuaPlannerRegularTransportSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getVenuaPlannerRegularTransportSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getVenuaPlannerRegularTransportSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetVenuaPlannerRegularTransportSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>>
    export type GetVenuaPlannerRegularTransportSuggestionsMutationBody = ListRequest
    export type GetVenuaPlannerRegularTransportSuggestionsMutationError = ErrorType<unknown>

    export const useGetVenuaPlannerRegularTransportSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetVenuaPlannerRegularTransportSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerTree = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetPlanningTreeResponse>(
      {url: `/api/venua-planner/tree`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerTreeQueryKey = () => {
    return [
    `/api/venua-planner/tree`
    ] as const;
    }

    
export const getGetVenuaPlannerTreeQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerTreeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerTree>>> = ({ signal }) => getVenuaPlannerTree(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerTree>>>
export type GetVenuaPlannerTreeQueryError = ErrorType<unknown>


export function useGetVenuaPlannerTree<TData = Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTree>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTree>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTree<TData = Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTree>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTree>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTree<TData = Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerTree<TData = Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerTreeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




